<template>
  <div class="personal">
    <Nav />
    <div style="height: 80px"></div>
    <div class="personal-bottom">
      <div class="personal-bottom-bottom">
        <div class="personal-bottom-bottom-left">
             <slide @change="changeSlide"></slide>
        </div>
        <div class="personal-bottom-bottom-right">
          <div class="personal-bottom-bottom-right-top">
            <div class="personal-bottom-bottom-right-top-left"></div>
            <el-breadcrumb
              class="daohang"
              separator-class="el-icon-arrow-right"
            >
              <el-breadcrumb-item
                class="maxtitle"
                :to="{ path: '/wodezichan' }"
              >
                <div class="title_box">
                  <span class="lines"></span>
                  <span>我的资产</span>
                </div>
              </el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <div class="personal-bottom-bottom-right-bottom">
            <div class="content_box" v-if="wodezichan">
              <div
                class="pay_list"
                v-for="(item, index) in wodezichan"
                :key="index"
              >
                <div class="pay_list_item">
                  {{ item.categoryName }}
                </div>
                <div
                  class="use_pay_quan"
                  v-for="(item, index) in item.gifts"
                  :key="index"
                >
                  <div class="vip_itme_img">
                    <img :src="item.iconUrl" />
                  </div>
                  <div class="vip_right_name">
                    <div class="name">
                      {{ item.name }}
                    </div>
                    <div class="desc">
                      {{ item.desc }}
                    </div>
                    <div class="order_date">
                      {{ dateFormat(item.expireTime) }} &nbsp;到期
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import qs from "qs";
import Nav from "../component/Nav.vue";
import slide from './template_slide.vue'
export default {
  name: "App",
  data() {
    return {
      serve: [
        {
          title: "个人信息",
          image: touxiang,
          serve: [
            {
              title1: "我的信息",
            },
            {
              title1: "我的关注",
            },
            {
              title1: "我的粉丝",
            },
            {
              title1: "历史观看",
            },
            {
              title1: "我的资产",
            },
            // {
            //   title1: "我的消息",
            // },
          ],
        },
        {
          title: "主播管理",
          image: zhiboguanli,
          serve: [
            {
              title1: "设置管理员",
            },
            {
              title1: "管理禁言",
            },
            {
              title1: "添加直播源",
            },
          ],
        },
        {
          title: "收益结算",
          image: shouyi,
          serve: [
            {
              title1: "我的收益",
            },
            {
              title1: "贡献排行榜",
            },
          ],
        },
        // {
        //     title:"发布中心",
        //     image:"https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngd2ec66790deb3159e04063619da5053fcf432ba3c86f79b8f020b58f5fb83d6d",
        //     serve:[
        //         {
        //             title1:"视频发布"
        //         },
        //         {
        //             title1:"资源管理"
        //         }
        //     ]
        // },
        {
          title: "数据中心",
          image: shuju,
          serve: [
            {
              title1: "直播数据",
            },
            // {
            //     title1:"视频数据"
            // }
          ],
        },
      ],
      b: 0,
      cooke: "",
      wodezichan: [],
      activeName: 0,
    };
  },
  created() {
    this.cooke = localStorage.getItem("token");
    console.log(this.cooke);
  },
  mounted() {
    this.Data();
  },
  methods: {
     changeSlide(data){
              this.$router.push(data);
            },
    Data() {
      this.$axios({
        url: this.api + "/v1/propety/list",
        method: "GET",
        headers: {
          device: "web",
          packageId: "1",
          version: "1.0.0",
          channel: "web",
          "authToken": localStorage.getItem("token"),
        },
      }).then((res) => {
        console.log(res);
        this.wodezichan = res.data.data;
      });
    },
    dateFormat: function (time) {
      var times = time * 1000;
      var date = new Date(times);
      var year = date.getFullYear();
      var month =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var hours =
        date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      var minutes =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      var seconds =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      // 拼接
      return (
        year +
        "-" +
        month +
        "-" +
        day +
        " " +
        hours +
        ":" +
        minutes +
        ":" +
        seconds
      );
    },
    Mingcheng(e, i) {
      console.log(e, i);
      if (e == 0 && i == 0) {
        this.$router.push("/personalc");
      }
      if (e == 0 && i == 1) {
        this.$router.push("/wodeguanzhu");
      }
      if (e == 0 && i == 2) {
        this.$router.push("/wodefensi");
      }
      if (e == 0 && i == 3) {
        this.$router.push("/lishiguankan");
      }
      if (e == 0 && i == 5) {
        this.$router.push("/wodexinxi");
      }
      if (e == 1 && i == 0) {
        this.$router.push("/shezhiguanliyuan");
      }
      if (e == 1 && i == 1) {
        this.$router.push("/guanlijinyan");
      }
      if (e == 1 && i == 2) {
        this.$router.push("/tianjiazhiboyuan");
      }
      if (e == 2 && i == 0) {
        this.$router.push("/wodeshouyi");
      }
      if (e == 2 && i == 1) {
        this.$router.push("/yonghupaihangbang");
      }
      // if (e == 3&&i == 0) {
      //     this.$router.push('/shipinfabu')
      // }
      // if (e == 3&&i == 1) {
      //     this.$router.push('/ziyuanguanli')
      // }
      if (e == 3 && i == 0) {
        this.$router.push("/zhiboshuju");
      }
      // if (e==4&&i==1) {
      //     this.$router.push('/shipinshuju')
      // }
    },
    dianji(e) {
      this.b = e;
    },
  },
  components: {
    Nav,
    slide
  },
};
</script>
<style>
.xzcxzcxz {
  color: #721edc !important;
}
.personal-bottom-bottom-left .el-collapse-item__header {
  box-sizing: border-box;
  padding-left: 20px;
  background-color: #fff;
  border-bottom: 0px solid #ebeef5;
  color: #333;
}
.personal-bottom-bottom-left .el-collapse-item__wrap {
  background: #f7f8fa;
  color: #333;
}
.personal-bottom-bottom-left .el-collapse-item__content {
  padding-bottom: 0px;
}
.personal-bottom-bottom-left .el-collapse-item__wrap {
  border-bottom: 0px solid #ebeef5;
}
.personal-bottom-bottom-left .el-collapse-item__content > div {
  text-align: center;
}
.personal-bottom-bottom-left .is-active {
  color: #721edc;
}
.personal-bottom-bottom-left .el-collapse {
  border-top: 0px solid #ebeef5;
  width: 100%;
}
.personal-bottom-bottom-left .el-collapse-item__wrap {
  background: #f7f8fa;
  color: #333;
}
</style>
<style scoped lang='scss'>
.sanjiao {
  width: 0;
  height: 0;
  border-top: 11px solid #ffffff;
  /* border-bottom-width: 11px; */
  /* border-radius: 0px; */
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  margin: 0 auto;
  margin-top: 15px;
}
.a {
  background-color: #721edc;
}
.xzcxzcxz {
  color: #721edc !important;
}
.personal-bottom-bottom-left .el-collapse {
  width: 100%;
  background: #f7f8fa;
}
.personal-bottom-bottom-left .el-collapse-item__wrap {
  background: #f7f8fa;
  color: #333;
}

.personal {
  width: 100vw;
  background: #f7f8fa;
   .title_box {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .lines {
        display: inline-block;
        width: 4px;
        margin-right: 6px;
        border-radius: 4px;
        height: 20px;
        background: #721edc;
      }
      span {
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #333333;
      }
    }
  .personal-bottom {
    background-color: #f7f8fa;
  }
  .personal-bottom-top {
    width: 100%;
    height: 60px;
    min-width: 1240px;
    background-color: #fff;
  }
  .personal-bottom-top-div {
    width: 1240px;
    height: 60px;
    margin: 0 auto;
    color: #333;
    font-size: 23px;
    line-height: 60px;
    display: flex;
    align-items: center;
  }
  .personal-bottom-top-div-div {
    width: 6px;
    height: 50px;
    background-color: #721edc;
    border-radius: 6px;
  }
}

.personal-bottom-bottom {
  width: 1200px;
  height: calc(100vh - 105px);
  margin: 0 auto;
  display: flex;
  background-color: #f7f8fa;
  min-width: 1200px;
  .personal-bottom-bottom-left {
    width: 190px;
    height: 100%;
    background-color: #fff;
    margin-top: 16px;
    color: #333;
    .myel-collapse-item {
      width: 190px;
    }
    .prent_item {
      text-align: center;
      width: 100%;
      height: 100%;
      display: flex;
      .parent_icon {
        display: flex;
        align-items: center;
      }
      .parent_name {
        display: flex;
        align-items: center;
        font-size: 14px;
      }
    }
    .child_item {
      color: #a6a6a6;
      width: 100%;
      height: 52px;
      line-height: 52px;
      background-color: #f2f2f2;
      .child_img {
        display: flex;
        align-items: center;
      }
      .child_name {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        text-align: center;
        cursor: pointer;
      }
    }
  }
}
.personal-bottom-bottom-right {
  margin-left: 12px;
  height: 100%;
  flex: 2;
  max-width: 998px;
  background-color: #fff;
  padding: 30px 20px 0 20px;
  box-sizing: border-box;
  margin-top: 16px;
}
.personal-bottom-bottom-right-top {
  background-color: #fff;
  display: flex;
  align-items: center;
  .xinxi {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
  }
  .xinxi:hover {
    color: #721edc;
  }
}
.personal-bottom-bottom-right-bottom {
  height: calc(94% - 15px);
  margin-top: 25px;
  padding-top: 15px;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  position: relative;
  box-sizing: border-box;
  .content_box {
    display: flex;
    flex-direction: column;
    .pay_list {
      display: flex;
      flex-flow: row wrap;
      margin-bottom: 12px;
      margin-top: 10px;
      cursor: pointer;

    }
    .pay_list_item {
      height: 20px;
      width: 100%;
      
    }
    .use_pay_quan {
      width: 330px;
      height: 112px;
      background: #f7f8fa;
      border-radius: 6px;
      box-sizing: border-box;
      margin-top: 15px;
      margin-left: 20px;
      border: 1px solid #a6a6a6;
      display: flex;
      .vip_itme_img {

        width: 160px;
        height: 112px;
        img {
          width: 160px;
          height: 112px;
        }
      }
      .vip_right_name {
        display: flex;
        flex-direction: column;
        padding: 12px 2px;
        .name {
          font-size: 14px;
          margin-bottom: 6px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          color: #333333;
        }
        .desc {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
        }
      }
      .order_date {
          flex: 2;
        display: flex;
        align-items: flex-end;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
      }
    }
  }
}
.daohang {
  display: flex;
  color: white;
  width: 500px;
  //   margin-left: 20px;
}

.maxtitle {
  font-size: 20px !important;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600 !important;
  color: #333333;

  span {
    font-weight: 600 !important;
    color: #333333;
  }
}
.xinxi {
  display: flex;
  align-items: center;
  font-size: 24px;
}
.biao {
  width: 16px;
  height: 16px;
  background-image: url(https://oss.ansongqiubo.com/assets/personimage/jiantou.png);
}
input {
  background: #464646;
  outline: none;
  border: 1px solid #464646;
}
input:focus {
  border: none;
}
</style>
<style>
.colorBiao {
  background-image: url(https://oss.ansongqiubo.com/assets/personimage/jiantou1.png) !important;
}
.a {
  background-color: #721edc;
}
</style>


// WEBPACK FOOTER //
// src/component/Wodezichan.vue